import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent {

  @Input() latitude: string = '';
  @Input() longitude: string = '';
  @Input() location: string = '';

  center: google.maps.LatLngLiteral = { lat: 0.0, lng: 0.0 }; 
  zoom = 14;
  markerPosition: google.maps.LatLngLiteral = { lat: 0.0, lng:0.0 };
  

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['latitude'] || changes['longitude']) {
      this.updateMap();
    }
  }

  private updateMap() {
    if (this.latitude && this.longitude) {
      this.center = { lat: parseFloat(this.latitude), lng: parseFloat(this.longitude) };
      this.markerPosition = this.center;
    }
  }
}
